import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { ref, reactive } from 'vue'
import {layer} from '@layui/layer-vue'

import { allPayLog } from '../../api'





export default /*#__PURE__*/_defineComponent({
  __name: 'payDetails',
  setup(__props) {

const search = reactive({
  key: "",
  state:"0", 
  rangeTime2:[]
  
})





const loading = ref(false);

    const selectedKeys = ref([]);

    const page = reactive({ current: 1, limit: 10, total: 0 });

    const columns = ref([ 
      { title:"订单编号", width: "150px", key:"orderid" ,align:"center"},
      { title:"账号", width: "80px", key:"userName",align:"center" },
      { title:"ip", width: "80px", key:"ip",align:"center" }, 
      { title:"金额", width: "150px", key:"amount",align:"center", totalRow: true},
      { title:"状态", width: "150px", key:"state",align:"center",customSlot:'state'},
      { title:"支付类型", width: "150px", key:"payType",align:"center",customSlot:'payType'},
      { title:"支付方式", width: "150px", key:"type",align:"center",customSlot:'type'},
      { title:"支付平台", width: "80px", key:"platformName",align:"center" },
      { title:"平台名称", width: "80px", key:"platformId",align:"center"},
      { title:"商户id", width: "80px", key:"memberid",align:"center" }, 
      { title:"隐藏", width: "260px", key:"hide", hide: true, totalRow: "合计" },
      { title:"创建时间", width: "80px", key:"addTime",align:"center" },
      { title:"结束时间", width: "80px", key:"dateTime",align:"center"},   
    ]);



    const getallPayLog = () => { 
          loading.value = true;
          var data = { "page": page.current, "limit": page.limit, "key": search.key, "state": search.state,"list":search.rangeTime2};
          allPayLog(JSON.stringify(data)).then((res: any) => {
            loading.value = false;
            if (res != "" && res.code == 0) {
              dataSource.value=[];
          
              dataSource.value = res.data;
              page.total = res.count;
            } else {
              dataSource.value = [];
              page.total = 0;
            }
          })

}

getallPayLog();





const qqueryPay = () => {
  getallPayLog();
}


    const change = (page:any) => {
  
      getallPayLog();
    }

    const sortChange = (key:any, sort:any) => {
      layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
    }

    const dataSource = ref([ ])
 




return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_date_picker = _resolveComponent("lay-date-picker")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "24" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form, {
                model: search,
                style: {"text-align":"start"},
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_form_item, {
                    label: "订单/用户名",
                    prop: "key",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: search.key,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                        placeholder: "请输入编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    label: "状态",
                    prop: "state",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: search.state,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.state) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select_option, {
                            value: "0",
                            label: "全部"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: "1",
                            label: "等待支付"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: "2",
                            label: "交易成功"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    label: "时间",
                    prop: "hobby",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_date_picker, {
                        modelValue: search.rangeTime2,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.rangeTime2) = $event)),
                        range: "",
                        type: "datetime",
                        placeholder: ['开始日期','结束日期']
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    mode: "inline",
                    style: {"text-align":"right"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_button, {
                        type: "primary",
                        size: "sm",
                        onClick: qqueryPay
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_lay_table, {
                page: page,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "data-source": dataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[3] || (_cache[3] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange
              }, {
                state: _withCtx(({ row }) => [
                  (row.state==0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "等待支付"))
                    : (row.state==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "支付失败"))
                      : (row.state==2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "支付成功"))
                        : _createCommentVNode("", true)
                ]),
                payType: _withCtx(({ row }) => [
                  (row.payType==0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "时长充值"))
                    : (row.payType==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "金币充值"))
                      : _createCommentVNode("", true)
                ]),
                type: _withCtx(({ row }) => [
                  (row.type==0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "支付宝"))
                    : (row.type==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "微信"))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})